// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3GwBx","image":"Header_image__2pGjy","name":"Header_name__-MM2L","info":"Header_info__hPptM","infoRow":"Header_infoRow__3Z70i"};